import type { JSX } from 'react';
import type { NavItem, PageId } from './routes';
import { navigate } from './use-route';

/** The centred page tabs; the active one is tinted, Health carries an error count. */
export function TopNav({
  items,
  active,
  badges,
}: {
  items: readonly NavItem[];
  active: PageId;
  badges: Partial<Record<PageId, number>>;
}): JSX.Element {
  return (
    <nav className="no-scrollbar order-2 hidden min-w-0 tab:flex flex-auto justify-center gap-0.5 overflow-x-auto py-1.5">
      {items.map((item) => {
        const on = item.page === active;
        const badge = badges[item.page] ?? 0;
        return (
          <button
            key={item.page}
            type="button"
            aria-current={on ? 'page' : undefined}
            onClick={() => navigate({ page: item.page })}
            className="hover:bg-surf2 hover:text-ink flex items-center gap-2 rounded-lg border-0 px-2.5 py-[7px] text-[13px] font-medium whitespace-nowrap transition-colors"
            style={{
              background: on ? 'var(--accSoft)' : 'transparent',
              color: on ? 'var(--acc)' : 'var(--mute)',
            }}
          >
            {item.label}
            {badge > 0 && (
              <span className="bg-bad rounded-full px-1.5 py-px font-mono text-[10.5px] text-white">
                {badge}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
